import { use } from 'react';
import { type ListDropdownItem } from '@sr/types';
import { DropdownContexts } from '../../../context/DropdownContext';
import { ListItemWrapper } from '../style';

type ListProps = {
  children?: React.ReactNode;
  item: ListDropdownItem;
  nestedIndex?: number;
};

export const ListItemSelectSimple = ({ children, item, nestedIndex }: ListProps) => {
  const { toggleValues, isItemSelected } = use(DropdownContexts.useValues);
  const { toggleOpen } = use(DropdownContexts.useDropdown);
  const handleClick = () => {
    toggleOpen();
    toggleValues([item.value]);
  };

  return (
    <ListItemWrapper
      isSelected={!!isItemSelected(item)}
      onClick={handleClick}
      data-testid="list-item"
      nestedIndex={nestedIndex}
    >
      {children}
    </ListItemWrapper>
  );
};
